export default __webpack_public_path__ + "static/media/logo-1440.8c71b065.svg";